import React, {Component} from 'react';
import {request} from "../../util/APIUtils";
import Table from "../../components/Table/Table";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {showAxiosError} from "../../util/Helpers";
import {API_BASE_URL} from "../../constants";
import {Modal, ModalBody, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane} from "reactstrap";
import OperatingCertificateForm from "./OperatingCertificateForm";
import classnames from "classnames";


class OperatingCertificate extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedMember: null,
            branches: null,
            members: [],
            totalIdList: [],
            certificateLogs: [],
            file: "",
            cities: [],
            loading: false,
            loading2: false,
            searching: false,
            searching2: false,
            searchQuery: "",
            searchQuery2: "",
            total: 0,
            total2: 0,
            page: 0,
            page2: 0,
            size: 10,
            size2: 10,
            manual: false,
            manual2: false,
            addOpCertModal: false,
            mode: 'create',
            func: null,
            activeTab: '1',
        };

        this.toggle = this.toggle.bind(this);
        this.listMembers = this.listMembers.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSearch2 = this.handleSearch2.bind(this);
        this.listCities = this.listCities.bind(this);
        this.listBranches = this.listBranches.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.cancelOpCert = this.cancelOpCert.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.listCertificateLogs = this.listCertificateLogs.bind(this);


    }

    componentDidMount() {
        this.listCities();
        this.listBranches();
    }

    listBranches() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/oda/oda-list/",
            method: "get",
        };
        console.log(params.url);
        request(params)
            .then(function (response) {
                let branches = response.data;
                console.log("branches", branches);
                self.setState({
                    branches,
                });
            }).catch(function (error) {
            showAxiosError(error);

        });
    }

    listCities() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/city/listByBranch/",
            method: "get",
        };
        console.log(params.url);
        request(params)
            .then(function (response) {
                let cities = response.data;
                self.setState({
                    cities,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }


    toggle(tab) {
        this.setState({
            activeTab: tab
        })
    }

    listMembers(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ("&sort=" + accessor + ',' + direction) : "&sort=id,asc";
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let url = API_BASE_URL + "/uye/fetchApprovedMemberByBranch?page=" + page + "&size=" + size + sortStr + searchQuery
        let params = {
            url: url,
            method: "get",
        };
        console.log(params.url);
        self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
        request(params)
            .then(function (response) {
                console.log(response.data.content);
                let members = (response.data && response.data.page) ? response.data.page.content : [];
                let totalIdList = response.data ? response.data.selectedIdList : [];
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.page.totalElements,
                    members,
                    totalIdList,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);

        });
    }


    listCertificateLogs(accessor2, direction2, page2, size2) {
        let self = this;
        let sortStr2 = !!accessor2 ? ("&sort=" + accessor2 + ',' + direction2) : "&sort=id,desc";
        let searchQuery2 = !self.state.searchQuery2 ? '' : '&' + self.state.searchQuery2;
        let url = API_BASE_URL + "/certificate-log/fetch?page=" + page2 + "&size=" + size2 + sortStr2 + searchQuery2;
        let params = {
            url: url,
            method: "get",
        };
        console.log(params.url);
        self.setState({loading2: true, manual2: self.manual2 === true ? false : self.manual2, searching2: true});
        request(params)
            .then(function (response) {
                console.log(response.data.content);
                let certificateLogs = response.data.content;
                self.setState({
                    page2: page2,
                    size2: size2,
                    total2: response.data.totalElements,
                    certificateLogs,
                    loading2: false,
                    searching2: false
                });
            }).catch(function (error) {
            self.setState({loading2: false, searching2: false});
            showAxiosError(error);

        });
    }

    handleEdit(item) {
        let self = this;
        let params = {
            url: API_BASE_URL + "/uye/" + item.id,
            method: 'get'
        };
        request(params).then(function (response) {
            self.setState({
                selectedMember: response.data,
                addOpCertModal: true
            })
        }).catch(function (error) {
            showAxiosError(error);
        });
    }

    cancelOpCert() {
        this.setState({
            addOpCertModal: false,
            selectedMember: null,
        })
    }

    /*handleExport(item) {
        let self = this;
        let params = {
            url: API_BASE_URL+"/uye/operating-certificate/" +item.id,
            method: 'get'
        };
        request(params).then(function (response) {
            const data=response.data.substring(response.data.indexOf(',')+1);
            var blob = b64toBlob(data,'application/pdf;charset=utf-8');
            FileSaver.saveAs(blob, item.tcKimlikNo+"_OdaKayitBelgesi.pdf");
        }).catch(function (error) {
            showAxiosError(error);
            if (error.response.status === 407) {
                self.handleLogout();
            }
        });
    }*/

    handleSearch(searchQuery) {
        this.setState({
            searchQuery,
            searching: true
        }, () => this.listMembers(this.state.accessor, this.state.direction, this.state.page, this.state.size))
    }

    handleSearch2(searchQuery2) {
        this.setState({
            searchQuery2,
            searching2: true
        }, () => this.listCertificateLogs(this.state.accessor2, this.state.direction2, 0, this.state.size2))
    }

    handleLogout() {
        this.props.handleLogout();
    }

    render() {
        const {members} = this.state;
        const {certificateLogs} = this.state;
        const {branches} = this.state;
        let selectdata;
        const header = [{value: null, label: "Tümü"},];

        branches ? selectdata = header.concat(branches) : selectdata = header;

        const columns = [
            {
                Header: "Ad",
                accessor: "ad",
            },
            {
                Header: "Soyad",
                accessor: "soyad",
            },
            {
                Header: "Sicil No",
                accessor: "odaSicilNo",
            },
            {
                Header: "Kayıt Tarihi",
                accessor: "",
                Cell: item => (
                    <label>{new Date(item.odaKayitTarihi).toLocaleDateString('tr')}</label>
                )
            },
            {
                Header: "Şehir",
                accessor: "",
                Cell: item => (
                    <label>{item.city.ad}</label>
                )
            },
            {
                Header: "Oda",
                accessor: "",
                Cell: item => (
                    <label>{item.city.oda.ad}</label>
                )
            },
            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <div>
                        <button type="button"
                                onClick={() => this.handleEdit(item)}
                                data-toggle="tooltip" data-placement="bottom" title="İndir"
                                style={{background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}
                                rel="tooltip" className="Btn btn-sm btn-icon">
                            <i className="fa fa-file"/>
                        </button>
                    </div>
                )
            }
        ];

        const columns2 = [
            {
                Header: "Tarih",
                accessor: "",
                Cell: item => (
                    <label>{new Date(item.certificateDate.toString().substring(0, item.certificateDate.toString().indexOf('T'))).toLocaleDateString('tr')}</label>
                    // <label>{new Date(item.certificateDate).toLocaleDateString('tr') }</label>
                )
            },
            {
                Header: "Ad",
                accessor: "",
                Cell: item => (
                    <label>{item.member.ad}</label>
                )
            },
            {
                Header: "Soyad",
                accessor: "",
                Cell: item => (
                    <label>{item.member.soyad}</label>
                )
            },
            {
                Header: "TC Kimlik No",
                accessor: "",
                Cell: item => (
                    <label>{item.member.tcKimlikNo}</label>
                )
            },
            {
                Header: "Oda Sicil No",
                accessor: "",
                Cell: item => (
                    <label>{item.member.odaSicilNo}</label>
                )
            },
            {
                Header: "Belge Tipi",
                accessor: "",
                Cell: item => (
                    <label>{item.certificateType === "HealthCertificate" ? "Meslek. M. Belgesi" : "Oda Kayıt Belgesi"}</label>
                )
            },
            {
                Header: "Doğrulama Kodu",
                accessor: "",
                Cell: item => (
                    <label>{item.barcode && item.barcode}</label>
                )
            },
            {
                Header: "Hes Kodu",
                accessor: "",
                Cell: item => (
                    <label>{item.hesCode && item.hesCode}</label>
                )
            },
            {
                Header: "Belgeyi Veren/Talep Eden",
                accessor: "",
                Cell: item => (
                    <label>{item.user.username}</label>
                )
            },


        ];


        const fields = [
            {
                label: "Ad",
                accessor: "ad",
                type: "text",
                operator: "=",
            },
            {
                label: "Soyad",
                accessor: "soyad",
                type: "text",
                operator: "=",
            },
            {
                label: "Oda Sicil No",
                accessor: "odaSicilNo",
                type: "text",
                operator: "=",
            },
            {
                label: "Oda",
                accessor: "city.oda.id",
                type: "select",
                operator: "=",
                selectData: selectdata,
            },
            {
                label: "TC Kimlik No",
                accessor: "tcKimlikNo",
                type: "text",
                operator: "=",
            },
            {
                label: "Telefon No",
                accessor: "telefonNo",
                type: "text",
                operator: "=",
            },

        ];

        const fields2 = [
            {
                label: "Ad",
                accessor: "member.ad",
                type: "text",
                operator: "=",
            },
            {
                label: "Soyad",
                accessor: "member.soyad",
                type: "text",
                operator: "=",
            },
            {
                label: "TC Kimlik No",
                accessor: "member.tcKimlikNo",
                type: "text",
                operator: "=",
            },
            {
                label: "Doğrulama Kodu",
                accessor: "barcode",
                type: "text",
                operator: "=",
            },
            {
                label: "Oda Sicil No",
                accessor: "mmeber.odaSicilNo",
                type: "text",
                operator: "=",
            },


        ];


        return (
            <div className="content user-form-container">
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({active: this.state.activeTab === '1'})}
                            onClick={() => {
                                this.toggle('1');
                            }}>
                            Belge İşlemleri
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({active: this.state.activeTab === '2'})}
                            onClick={() => {
                                this.toggle('2');
                            }}>
                            Belge Döküm Tarihçesi
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab} className="tab-content">
                    <TabPane tabId="1">
                        <div className="row baseBackground">

                            <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                <DetailedSearch fields={fields}
                                                loading={this.state.searching}
                                                onSearch={this.handleSearch}/>
                            </div>
                            <div className="card-body">
                                <Table
                                    loading={this.state.loading}
                                    loadingText="Kayıtlar getiriliyor..."
                                    content={members}
                                    total={this.state.total}
                                    page={this.state.page}
                                    manual={this.state.manual}
                                    size={this.state.size}
                                    options={["5", "10", "20", "50", "100"]}
                                    columns={columns}
                                    fetchData={this.listMembers}
                                />
                            </div>
                        </div>
                    </TabPane>
                    <TabPane tabId="2">

                        <div className="row baseBackground">
                            <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                <DetailedSearch fields={fields2}
                                                loading={this.state.searching2}
                                                onSearch={this.handleSearch2}/>
                            </div>
                            <div className="card-body">
                                <Table
                                    loading={this.state.loading2}
                                    loadingText="Kayıtlar getiriliyor..."
                                    content={certificateLogs}
                                    total={this.state.total2}
                                    page={this.state.page2}
                                    manual={this.state.manual2}
                                    size={this.state.size2}
                                    options={["5", "10", "20", "50", "100"]}
                                    columns={columns2}
                                    fetchData={this.listCertificateLogs}
                                />
                            </div>
                        </div>
                    </TabPane>

                </TabContent>
                <Modal isOpen={this.state.addOpCertModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelOpCert}>
                        Belge Dökümü
                    </ModalHeader>
                    {<ModalBody>
                        <OperatingCertificateForm cancelProcess={this.cancelOpCert}
                                                  selectedMember={this.state.selectedMember} mode={this.state.mode}
                                                  module={this.props.name} cities={this.state.cities}
                                                  branches={this.state.branches} handleSearch={this.handleSearch}
                                                  searchQuery={this.state.searchQuery}
                                                  currentUser={this.props.currentUser}
                                                  handleLogout={this.handleLogout}/>
                    </ModalBody>
                    }
                </Modal>
            </div>
        )
    }
}

export default OperatingCertificate



// WEBPACK FOOTER //
// ./src/page/operatingCertificate/OperatingCertificate.js